export const SWEDISH_TIME_ZONE = 'Europe/Stockholm';

const timestampFormatter = new Intl.DateTimeFormat('sv-SE', {
  timeZone: SWEDISH_TIME_ZONE,
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
});

/** Format an actual instant in Sweden, independently of the browser time zone. */
export function swedishTimestamp(instant: Date = new Date()): string {
  const parts = timestampFormatter.formatToParts(instant);
  const part = (name: string) => parts.find(value => value.type === name)!.value;
  return `${part('year')}-${part('month')}-${part('day')}T${part('hour')}:${part('minute')}:${part('second')}`;
}

export function swedishFileTimestamp(instant: Date = new Date()): string {
  return swedishTimestamp(instant).replace('T', '_').replace(/:/g, '-');
}

